import { Record } from 'immutable';

export const mkInvestmentsNewsfeed = Record({
  id: undefined,
  categories: undefined,
  timestamp: undefined,
  source: undefined,
  headline: undefined,
  external: undefined,
  headlineURL: undefined,
  pdfURL: undefined,
  preview: undefined,
  imageURL: undefined,
  imageCaption: undefined,
  publishDate: undefined,
  fullText: undefined,
  relatedSymbols: undefined,
  canonicalUrl: undefined,
  organization: undefined,
});
